import * as Yup from 'yup'

import {
  acceptConditions,
  confirmEmail,
  confirmPassword,
  email,
  firstName,
  lastName,
  password,
  phone,
  rut,
} from '../../utils/yup'

export const REGISTER_SCHEMA_STEP_ONE = Yup.object().shape({
  phone,
  email,
  confirmEmail,
})

export const REGISTER_SCHEMA_STEP_TWO = Yup.object().shape({
  firstName,
  lastName,
  rut,
})

export const REGISTER_SCHEMA_STEP_THREE = Yup.object().shape({
  password,
  confirmPassword,
  acceptConditions,
})
